"use client";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import highchartsVenn from "highcharts/modules/venn";

highchartsVenn(Highcharts);

function VennChart({ data, serieName }) {
  // data = [
  //         {
  //           sets: ["Good"],
  //           value: 2,
  //           name: "Good"
  //         },
  //         {
  //           sets: ["Fast"],
  //           value: 2,
  //           name: "Fast"
  //         }]
  const options = {
    series: [
      {
        type: "venn",
        data,
        name: serieName,
      },
    ],
    title: {
      text: "",
    },
  };
  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
}
export default VennChart;
